import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import "react-querybuilder/dist/query-builder.css";
import { ValidatorForm } from "react-form-validator-core";

import Paginated from "./Paginated";
import { COLUMNS } from "./addColumn";
import Header from "../../layout/Header";
import { getMembership } from "../../../actions/auth";
import TextValidator from "../../partial/TextValidator";
import SelectValidator from "../../partial/SelectValidator";
import { addMembership, updateMembershipType } from "../campaigns/services";

function AddMembership() {
  const currencyType = [
    { label: "INR", value: "INR" },
    { label: "USD", value: "USD" },
    { label: "AED", value: "AED" },
  ];
  const [membershipId, setMembershipId] = useState();
  const [currencyValue, setCurrencyValue] = useState();
  const [loader, setLoader] = useState(false);
  const [list, setList] = useState([]);
  const [formData, setFormData] = useState({
    membershipName: "",
    fee: "",
    currency: [],
  });

  const { membershipName, fee } = formData;

  useEffect(() => {
    fetchMembershipData();
  }, []);

  const fetchMembershipData = async () => {
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("token_gen"));
    const id = localStorage.getItem("Id");
    const res = await getMembership(token?.access_token, id);
    if (Array.isArray(res?.data) && res?.data?.length > 0) {
      if (res.data) {
        let serialNumber = 1;
        res.data?.map((val, ind) => {
          val.sNo = serialNumber++;
          val.membershipName = val.membershipName;
          val.currency =
            val?.currency?.length > 1
              ? val.currency.map((ele) => `${ele} `)
              : val.currency;
          val.action = (
            <>
              <Link
                className="edit_btn"
                onClick={() => {
                  setFormData({
                    membershipName: val?.membershipName,
                    fee: val?.fee,
                    currency: val?.currency,
                  });
                  setCurrencyValue(
                    val?.currency?.length > 1
                      ? val.currency.map((ele) => ele?.trim())
                      : val.currency
                  );
                  setMembershipId(val.membershipId);
                  window.scrollTo(0, 0);
                }}
                style={{ display: "flex", justifyContent: "center" }}
                csvalue="Edit"
              >
                <i className="fa-solid fa-pen"></i>
                <div className="show_div">Edit</div>
              </Link>
            </>
          );
          return val;
        });
      }
      setList(res?.data);
    }
    setLoader(false);
  };

  const resetForm = () => {
    if (membershipId) setMembershipId("");
    setCurrencyValue([]);
    setFormData({
      membershipName: "",
      fee: "",
      currency: [],
    });
  };

  const onChange = (e) => {
    setFormData({ ...formData, ...{ [e.target.name]: e.target.value } });
  };

  const handleCurrency = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setCurrencyValue(selectedValues);
    setFormData({ ...formData, currency: selectedValues });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    const token = JSON.parse(localStorage.getItem("token_gen"));
    const merchantCode = localStorage.getItem("Id");
    if (membershipId) {
      const response = await updateMembershipType(
        token?.access_token,
        membershipId,
        formData
      );
      if (response?.message === "Membership updated successfully.") {
        swal({
          position: "center",
          icon: "success",
          title: "Membership Updated",
          showConfirmButton: false,
          timer: 2000,
        });
        fetchMembershipData();
        resetForm();
      } else {
        swal({
          position: "center",
          icon: "error",
          title: response?.message,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    } else {
      const response = await addMembership(
        token?.access_token,
        merchantCode,
        formData
      );
      if (response?.message === "Membership data created successfully.") {
        swal({
          position: "center",
          icon: "success",
          title: "Membership Created",
          showConfirmButton: false,
          timer: 2000,
        });
        fetchMembershipData();
        resetForm();
      } else {
        swal({
          position: "center",
          icon: "error",
          title: response?.message,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    }
    setLoader(false);
  };

  return (
    <div>
      <Header name={"Membership"} />
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <div className="dashboard__content">
        <ValidatorForm
          onSubmit={onSubmit}
          className="dashboard__customerViewMain"
        >
          <div className="dashboard__transactionsCard">
            <div className="dashboard__header">
              <div className="dashboard__left">
                <h4 membershipId="transction_list">
                  {membershipId ? "Update" : "Add"} Membership
                </h4>
              </div>
            </div>
            <div className="dashboard__customerViewCard">
              <div className="row mb-3">
                <div className="col-md-6">
                  <div className="row">
                    <label className="col-md-4 col-form-label">
                      Membership Name
                    </label>
                    <div className="col-md-8">
                      <TextValidator
                        className="form-control"
                        validators={["required"]}
                        value={membershipName}
                        placeholder="Membership Name"
                        name="membershipName"
                        maxLength="50"
                        errorMessages={"Membership name is required"}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="row">
                    <label className="col-md-4 col-form-label">Fee</label>
                    <div className="col-md-8">
                      <TextValidator
                        className="form-control"
                        value={fee}
                        placeholder="Enter Fee"
                        name="fee"
                        maxLength="50"
                        validators={["required", "matchRegexp:^\\d*(\\.\\d+)?$"]}
                        errorMessages={["Fee is required", "Please enter a valid fee"]}
                        onChange={onChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="row">
                    <label className="col-md-4 col-form-label">Currency</label>
                    <div className="col-md-8">
                      <SelectValidator
                        isMulti
                        validators={["required"]}
                        options={currencyType}
                        value={currencyType.filter((option) =>
                          currencyValue?.includes(option.value)
                        )}
                        onChange={handleCurrency}
                        errorMessages={"Currency is required"}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-6 d-flex justify-content-end align-items-center">
                  <button type="submit" className="btn btn-primary">
                    {membershipId ? "Update" : "Create"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ValidatorForm>
        <div className="dashboard__customersCard">
          <div className="dashboard__header">
            <div className="dashboard__left">
              <h4 id="transction_list">Membership</h4>
            </div>
          </div>
          <div className="dashboard__body">
            <Paginated data={list ? list : []} columns={COLUMNS} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddMembership;
